import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axios/axiosInstance";

export interface AppointmentCharge {
    id: number;
    hospital_charge: number;
    doctor_charge: number;
    status: number;
    appointment_type_id: number;
    doctor_id: number;
    createdAt: string; // ISO date string
    updatedAt: string; // ISO date string
    appointmentType: AppointmentType | null;
    doctor: Doctor | null;
  }

  export interface AppointmentType {
    id: number;
    type: string;
    createdAt: string; // ISO date string
    updatedAt: string; // ISO date string
  }

  export interface Doctor {
    id: number;
    name: string;
    description: string;
    contact: string;
    degree: string;
    address: string;
    nic: string;
    register_no: string;
    gender: string;
    languages: string;
    experience: string;
    img: string; // URL of the image
    system_user_id: number;
    birthday: string; // ISO date string
    created_by: number;
    updated_by: number;
    status: number;
    createdAt: string; // ISO date string
    updatedAt: string; // ISO date string
  }
  

interface AppointmentChargeState {
    appointmentCharge: AppointmentCharge;
    loading: boolean;
    error: string | null;
}

const initialState: AppointmentChargeState = {
    appointmentCharge: {
        id: 0,
        hospital_charge: 0,
        doctor_charge: 0,
        status: 0,
        appointment_type_id: 0,
        doctor_id: 0,
        createdAt: '',
        updatedAt: '',
        appointmentType: null,
        doctor: null
    },
    loading: false,
    error: null,
};

// Async thunk for fetching active blog categories
export const fetchAppointmentCharge = createAsyncThunk<any,{doctor_id: number, appointment_type_id: number|undefined,is_local: number}>(
    'charge/fetchAppointmentCharge',
    async ({doctor_id, appointment_type_id,is_local}, { rejectWithValue }) => {
        try {
            // const baseUrl = process.env.API_URL;
            const response = await axiosInstance.get(
                `/appointment-charge/doctor/${doctor_id}/type/${appointment_type_id}/is_local/${is_local}` 
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message || 'Failed to fetch symptom'
            );
        }
    }
);

const appointmentChargeSlice = createSlice({
    name: 'charge',
    initialState,
    reducers: {
        // Add other actions here
    }, extraReducers: (builder) => {
        builder
            .addCase(fetchAppointmentCharge.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAppointmentCharge.fulfilled, (state, action) => {
                state.loading = false;
                state.appointmentCharge = action.payload;
            })
            .addCase(fetchAppointmentCharge.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export default appointmentChargeSlice.reducer;
